<template>
  <div style="overflow: hidden;width: 100%;height: 100%;">
    <div style="width: 100%;height: 100%;">
      <el-table ref="table" :data="floorData1" border stripe style="width: 100%;"
                :header-cell-style="{textAlign: 'center',height: '26px'}"
                :cell-style="{ textAlign: 'center', width: '100%',height: '43px'}" :height="tableHeight" >
        <el-table-column prop="wujian_name" label="物件名称" min-width="120" fixed/>
        <el-table-column prop="floor" label="楼层" min-width="60" fixed/>
        <el-table-column prop="advance_floor" label="先行楼层" min-width="130" fixed/>
        <el-table-column prop="balance" label="结余" min-width="60" fixed/>
        <el-table-column prop="weight" label="重量(KG)" min-width="70">
          <template v-slot="scope">
            {{scope.row.weight.toLocaleString()}}
          </template>
        </el-table-column>
        <el-table-column prop="unit_num" label="单元数量" min-width="60" />
        <el-table-column prop="area" label="面积(㎡)" min-width="60" >
          <template v-slot="scope">
            {{scope.row.area.toLocaleString()}}
          </template>
        </el-table-column>

        <el-table-column :label="dateList1[index].years" v-for="(item,index) in dateList1" :key="item.index">
          <el-table-column :label="item.monthList[index].day" v-for="(list,index) in item.monthList" :key="list.date">
            <el-table-column :label="item.monthList[index].week" min-width="20">
              <template v-slot="scope">
                <div v-for="plannedActual in scope.row.planned_actual" :key="plannedActual.lot">
                  <div v-if="item.monthList[index].date == plannedActual.date">
                    <div style="height: 13px">
                      <div v-if="plannedActual.jiagong_plan" class="div" style="background: rgba(255 245 204);border:rgba(255 204 0) solid 1px;"></div>
                      <div v-if="plannedActual.jiagong_plan == null" class="div" style="background: rgba(255 255 255);border:rgba(255 255 255) solid 1px;"></div>
                      <div v-if="plannedActual.jiagong_actual" class="div" style="background: rgba(255 204 0);width: 100%;"></div>
                    </div>
                    <div style="height: 13px">
                      <div v-if="plannedActual.tuzhuang_plan" class="div" style="background: rgba(229 181 255);border:rgba(166 0 255) solid 1px "></div>
                      <div v-if="plannedActual.tuzhuang_plan == null" class="div" style="background: rgba(255 255 255);border:rgba(255 255 255) solid 1px;"></div>
                      <div v-if="plannedActual.tuzhuang_actual" class="div" style="background: rgba(166 0 255);"></div>
                    </div>
                    <div style="height: 13px">
                      <div v-if="plannedActual.zuli_plan" class="div" style="background: #DBFCC9;border: #94D82D solid 1px "></div>
                      <div v-if="plannedActual.zuli_plan == null" class="div" style="background: rgba(255 255 255);border:rgba(255 255 255) solid 1px;"></div>
                      <div v-if="plannedActual.zuli_actual" class="div" style="background: #94D82D"></div>
                    </div>

                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "ZhiZaoKanBan1",
  data() {
    return {
      planAchievementsLoading:false,
      total: 0,
      pageNo: 1,
      formData: {
        wujianId: '',
        quarter:'',
        startMonth:this.getDateFormat(),
        endMonth:this.getDateFormat()
      },
      maxHeight:'',
      wujianNameLlist: [],
      floorData: [],
      dateList: [],
      dateList1: [],
      floorData1: [],
      currentIndex:0,
      currentIndex1:0,
      tableHeight: window.innerHeight - 70,
      intervalId: null,
      cnt:0,
    }
  },
  methods: {
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString()
    },
    currentCheckChange(pageNo) {
      this.pageNo= pageNo
      this.total = this.floorData.length
    },
    //获取物件名称
    getAllWujianName() {
      this.$axios.post('mfg/materialConfirm/getAllWujianName',).then(response => {
        let res = response.data
        this.wujianNameLlist = res.data

      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    },
    getPlanAchievementsData(){
      //判断开始时间是否大于结束时间
      let startMonth = Date.parse(new Date(this.formData.startMonth));
      let endMonth = Date.parse(new Date(this.formData.endMonth));
      if (startMonth > endMonth){
        return this.$message.error('开始月份不能大于结束月份！')
      }
      this.planAchievementsLoading = true;
      this.$axios.post('mfg/planAchievements/getPlanAchievementsData',this.formData).then(response => {
        let res = response.data
        if (res.code === 0) {
          this.dateList = res.data.dateList
          this.floorData = res.data.floorData
          this.planAchievementsLoading = false;
          //初始4条
          this.dateList1 = this.dateList.slice(this.currentIndex, this.currentIndex + this.cnt);
          this.currentIndex = this.cnt;
          if (this.currentIndex > this.dateList.length) {
            this.currentIndex = 0;
          }

          this.floorData1 = this.floorData.slice(this.currentIndex1, this.currentIndex1 + this.cnt);
          this.currentIndex1 = this.cnt;
          if (this.currentIndex1 > this.floorData.length) {
            this.currentIndex1 = 0;
          }
        }
      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    },
    //每过10秒切换4条
    startDataRefresh() {
      this.intervalId = setInterval(() => {
        this.dateList1 = this.dateList.slice(this.currentIndex, this.currentIndex + 4);
        this.currentIndex += this.cnt;
        if (this.currentIndex >= this.dateList.length) {
          this.currentIndex = 0; // 循环到数据末尾时重置索引
        }

        this.floorData1 = this.floorData.slice(this.currentIndex1, this.currentIndex1 + this.cnt);
        this.currentIndex1 += this.cnt;
        if (this.currentIndex1 > this.floorData.length) {
          this.currentIndex1 = 0;
        }
      }, 10000); // 每10秒更新一次
    },
    //每过10秒切换4条
    stopDataRefresh() {
      clearInterval(this.intervalId)
    },
    getCnt() {
      let tableHeight = this.$refs.table.$el.offsetHeight;
      console.log("tableHeight=="+tableHeight)
      let cnt = (tableHeight - 78) / 43
      console.log("tableHeight=="+Math.floor(cnt))
      this.cnt = cnt;
    }
  },
  mounted() {
    // window.onresize:浏览器尺寸变化响应事件
    window.onresize = () => {
      return (() => {
        // window.innerHeight:浏览器的可用高度
        window.screenHeight = window.innerHeight;
        this.tableHeight = window.screenHeight - 70;
      })();
    };
    this.getCnt();
  },
  created() {
    //this.getMaxHeight()
    this.getAllWujianName()
    this.getPlanAchievementsData()
    this.startDataRefresh()
  },unmounted() {
    this.stopDataRefresh();
  }
}
</script>

<style scoped>
.dotClass {
  width: 12px;
  height: 12px;
  border: black;
  display: block;
}

.div {
  width: 100%;
  height: 6px;
  margin-top: 1px;
}

.el-table :deep(.cell) {
  padding: 0;
}

.el-table :deep(.el-table__cell) {
  padding: 0;
}
.pageStyle {
  width: 100%;
  display: flex;
  justify-content:flex-end;
  margin: 20px 0
}

/* 隐藏滚动条 */
::-webkit-scrollbar {
  width: 0;
  background: transparent; /* 使滚动条透明 */
}

</style>